import { breakPoints } from 'app/components/v2/constants/styles';

import { Device } from './contexts';

export function getDeviceFromWidth(width: number): Device {
  if (width > breakPoints.tablet) {
    return 'desktop';
  }

  if (width <= breakPoints.mobile) {
    return 'mobile';
  }

  return 'tablet';
}
